
<div class="field" #fieldName>
    <span class="field-title">Puerto<span class="asterisk" *ngIf="requirePort">*</span></span>
    <div>
        <div class="form-field" [ngClass]="{'border-green': isOptionSelected, 'is-incomplete': isInvalid || (incompleteRequirePort && !elementSelected)}"
            (click)="changeShowOptions()">
            <span class="title-field">

                <span class="autocomplete"> 
                    <span class="first-part">{{search}}</span> 
                    <span class="second-part">{{placeHolder}}</span>
                </span>

                <input  #inputName2 (focus)="focusField(fieldName);" (keydown)="listenerTab($event)"
                    (blur)="unfocusField()" value="{{elementSelected}}" [(ngModel)]="search" placeholder="{{initalElementSelected}}" class="{{identifyClassName}} no-background-border"/>
                <!-- <arrow-svg  [active]="true" [direction]="arrowDirection"></arrow-svg> -->
                <img alt="arrow-green" class="{{arrowDirection}}" (mouseup)="focusInInput(inputName2)"
                    src="../../../../../../assets/images/extra/arrow-down-green.svg" />
            </span>
        </div>
        <span class="text-is-incomplete" *ngIf="isInvalid">Destino no admitido para la corredora seleccionada.</span>
        <span class="text-is-incomplete" *ngIf="incompleteRequirePort && !elementSelected">Completar la siguiente información para continuar.</span>

        <div class="options" *ngIf="showOptions">
            <span *ngFor="let element of array |  filterByObject: search:OBJECT: 'port'; index as i" [ngClass]="{'selected': element==elementSelected}"
                (click)="setElement(element, i)">
                {{element}}
            </span>
        </div>
    </div>
</div>